// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   LISTA CAMPEONATOS — Drawer de Edição
   ============================================= */

/* Toast de notificação */
.lc-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  padding: 14px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  animation: lc-slide-in 0.3s ease;
  max-width: 380px;
}
.lc-toast-success { background: #10B981; }
.lc-toast-error   { background: #EF4444; }
.lc-toast-warning { background: #F59E0B; }

@keyframes lc-slide-in {
  from { transform: translateX(120%); opacity: 0; }
  to   { transform: translateX(0); opacity: 1; }
}

/* ── Card: Badge de status ─────────────────── */
.camp-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 0.5px;
  z-index: 1;
}

.camp-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255,255,255,0.7);
}

/* ── Card: Meta info ───────────────────────── */
.camp-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}
.camp-meta-item {
  font-size: 13px;
  color: #4B5563;
}

/* ── OVERLAY ───────────────────────────────── */
.ed-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  animation: overlay-in 0.25s ease;
}
@keyframes overlay-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ── DRAWER ────────────────────────────────── */
.ed-drawer {
  width: 520px;
  max-width: 95vw;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 40px rgba(0,0,0,0.18);
  animation: drawer-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}
@keyframes drawer-in {
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
}

/* ── Header ────────────────────────────────── */
.ed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 24px;
  border-bottom: 1px solid #F3F4F6;
  background: #FAFAFA;
  flex-shrink: 0;
}
.ed-header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ed-status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}
.ed-title {
  font-size: 17px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 340px;
}
.ed-subtitle {
  font-size: 12px;
  color: #9CA3AF;
  font-weight: 500;
}
.ed-close-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: #F3F4F6;
  color: #6B7280;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}
.ed-close-btn:hover {
  background: #EF4444;
  color: white;
}

.ed-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.ed-delete-header-btn {
  background: #FFF5F5;
  color: #B91C1C;
  border: 1px solid #FEE2E2;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.ed-delete-header-btn:hover {
  background: #EF4444;
  border-color: #EF4444;
  color: #fff;
}

.ed-delete-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 24px;
  background: #FFF5F5;
  border-bottom: 1px solid #FEE2E2;
  font-size: 13.5px;
  color: #7F1D1D;
}
.ed-delete-banner-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

/* ── Tabs ──────────────────────────────────── */
.ed-tabs {
  display: flex;
  border-bottom: 1px solid #E5E7EB;
  overflow-x: auto;
  flex-shrink: 0;
  background: #fff;
  padding: 0 16px;
}
.ed-tabs::-webkit-scrollbar { height: 3px; }
.ed-tab {
  white-space: nowrap;
  padding: 14px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #9CA3AF;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}
.ed-tab:hover { color: #111827; }
.ed-tab.active {
  color: #111827;
  border-bottom-color: #111827;
}

/* ── Body ──────────────────────────────────── */
.ed-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}
.ed-body::-webkit-scrollbar { width: 6px; }
.ed-body::-webkit-scrollbar-track { background: #F9FAFB; }
.ed-body::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 3px; }

.ed-section {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Inscritos ─────────────────────────────── */
.ed-insc-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
}
.ed-insc-stat {
  background: #F9FAFB; border: 1px solid #E5E7EB; border-radius: 12px;
  padding: 14px 16px; display: flex; flex-direction: column; gap: 4px;
}
.ed-insc-stat span { font-family: 'JetBrains Mono', monospace; font-size: 20px; font-weight: 600; color: #111827; }
.ed-insc-stat small { font-size: 11.5px; color: #6B7280; text-transform: uppercase; letter-spacing: .03em; }
.ed-insc-stat-green span { color: #0F4A2A; }
.ed-insc-stat-amber span { color: #4A2F08; }
.ed-insc-stat-cobalt { background: #FEE2E2; border-color: #F5B5B5; }
.ed-insc-stat-cobalt span { color: #991B1B; }

.ed-insc-table thead th:last-child { width: 1%; }
.ed-insc-atleta { display: flex; align-items: center; gap: 10px; border-left: 3px solid var(--faixa-cor, #DEDACB); padding-left: 8px; }
.ed-insc-atleta div { display: flex; flex-direction: column; gap: 1px; }
.ed-insc-atleta b { font-size: 13.5px; color: #111827; }
.ed-insc-atleta small { font-size: 11.5px; color: #6B7280; }
.ed-insc-avatar {
  flex-shrink: 0; width: 30px; height: 30px; border-radius: 50%;
  background: #FEE2E2; color: #991B1B;
  display: flex; align-items: center; justify-content: center;
  font-size: 11.5px; font-weight: 700;
}
.ed-insc-valor { font-family: 'JetBrains Mono', monospace; font-size: 13px; }

/* ── Fields ────────────────────────────────── */
.ed-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}
.ed-field label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.ed-field input,
.ed-field select,
.ed-field textarea {
  padding: 10px 14px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}
.ed-field input:focus,
.ed-field select:focus,
.ed-field textarea:focus {
  outline: none;
  border-color: #111827;
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.08);
}
.ed-field-row {
  display: flex;
  gap: 12px;
}
.ed-field-small {
  max-width: 120px;
}
.required { color: #EF4444; }

/* ── Info box ──────────────────────────────── */
.ed-info-box {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  color: #1E40AF;
}
.ed-hint {
  font-size: 12px;
  color: #9CA3AF;
  margin: 0;
}

/* ── Capa ──────────────────────────────────── */
.ed-capa-preview {
  border-radius: 12px;
  overflow: hidden;
  background: #F3F4F6;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ed-capa-img {
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  display: block;
}
.ed-capa-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #9CA3AF;
  font-size: 14px;
  min-height: 180px;
}
.ed-capa-empty span { font-size: 40px; }
.ed-upload-btn {
  display: inline-block;
  background: #111827;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  text-align: center;
}
.ed-upload-btn:hover { background: #374151; }
.ed-remove-capa {
  background: none;
  border: 1.5px solid #EF4444;
  color: #EF4444;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.ed-remove-capa:hover { background: #EF4444; color: white; }

/* ── Premiações / Lotes ────────────────────── */
.ed-list-item {
  display: flex;
  gap: 12px;
  align-items: center;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 14px;
}
.ed-list-item-body {
  display: flex;
  gap: 12px;
  flex: 1 1;
}
.ed-remove-item {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: #FEE2E2;
  color: #EF4444;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s;
}
.ed-remove-item:hover { background: #EF4444; color: white; }
.ed-add-btn {
  background: none;
  border: 2px dashed #D1D5DB;
  color: #6B7280;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}
.ed-add-btn:hover { border-color: #111827; color: #111827; }

/* ── Status Selector ───────────────────────── */
.ed-status-selector {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ed-status-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 2px solid #E5E7EB;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}
.ed-status-option.selected {
  border-color: var(--status-color);
  background: color-mix(in srgb, var(--status-color) 10%, white);
  color: var(--status-color);
}
.ed-status-option:hover {
  border-color: var(--status-color);
}

/* ── Zona de Perigo ────────────────────────── */
.ed-danger-zone {
  margin-top: 8px;
  border: 2px solid #FEE2E2;
  border-radius: 12px;
  padding: 20px;
  background: #FFF5F5;
}
.ed-danger-zone h4 {
  margin: 0 0 8px;
  color: #991B1B;
  font-size: 15px;
}
.ed-danger-zone p {
  font-size: 13px;
  color: #7F1D1D;
  margin: 0 0 16px;
}
.ed-delete-btn {
  background: #EF4444;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.ed-delete-btn:hover { background: #DC2626; }
.ed-confirm-delete p {
  font-size: 13px;
  color: #991B1B;
  margin-bottom: 12px;
}
.ed-confirm-btns {
  display: flex;
  gap: 10px;
}
.ed-cancel-btn {
  background: #F3F4F6;
  color: #374151;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.ed-cancel-btn:hover { background: #E5E7EB; }

/* ── Footer ────────────────────────────────── */
.ed-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  border-top: 1px solid #E5E7EB;
  background: #FAFAFA;
  flex-shrink: 0;
}
.ed-btn-cancel {
  background: #F3F4F6;
  color: #374151;
  border: none;
  padding: 11px 22px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.ed-btn-cancel:hover { background: #E5E7EB; }
.ed-btn-save {
  background: #111827;
  color: white;
  border: none;
  padding: 11px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(17, 24, 39, 0.3);
}
.ed-btn-save:hover:not(:disabled) { background: #374151; }
.ed-btn-save:disabled,
.ed-btn-cancel:disabled { opacity: 0.6; cursor: not-allowed; }

/* ── Textarea fields ─────────────────────────── */
.ed-field textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: #111827;
  background: #FAFAFA;
  resize: vertical;
  transition: border-color 0.2s;
  line-height: 1.6;
}
.ed-field textarea:focus {
  outline: none;
  border-color: #6366F1;
  background: white;
  box-shadow: 0 0 0 3px rgba(99,102,241,0.08);
}

/* ── Checkbox group ──────────────────────────── */
.ed-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  background: #F9FAFB;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
}
.ed-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  cursor: pointer;
}
.ed-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #6366F1;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ListaCampeonatos.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;AACA,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,EAAE,UAAU,EAAE;AAC/C;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,uDAAuD;EACvD,gBAAgB;AAClB;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,8BAA8B,WAAW,EAAE;AAC3C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,oBAAoB;AACtB;AACA,gBAAgB,cAAc,EAAE;AAChC;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;AACA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE7E;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB;EACnE,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACrE;AACA,qBAAqB,wCAAwC,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClH,sBAAsB,iBAAiB,EAAE,cAAc,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC3G,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,4BAA4B,cAAc,EAAE;;AAE5C,qCAAqC,SAAS,EAAE;AAChD,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gDAAgD,EAAE,iBAAiB,EAAE;AACtI,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACvE,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;AACvD,wBAAwB,iBAAiB,EAAE,cAAc,EAAE;AAC3D;EACE,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7D,mBAAmB,EAAE,cAAc;EACnC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB,EAAE,gBAAgB;AACrC;AACA,iBAAiB,wCAAwC,EAAE,eAAe,EAAE;;AAE5E,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA,YAAY,cAAc,EAAE;;AAE5B,iDAAiD;AACjD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA,sBAAsB,eAAe,EAAE;AACvC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;;AAE3D,iDAAiD;AACjD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;AACA,oBAAoB,qBAAqB,EAAE,cAAc,EAAE;;AAE3D,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,8DAA8D;EAC9D,0BAA0B;AAC5B;AACA;EACE,iCAAiC;AACnC;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C,iDAAiD;AACjD;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2CAA2C;AAC7C;AACA,oCAAoC,mBAAmB,EAAE;AACzD;0BAC0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["/* =============================================\n   LISTA CAMPEONATOS — Drawer de Edição\n   ============================================= */\n\n/* Toast de notificação */\n.lc-toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  padding: 14px 22px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.2);\n  animation: lc-slide-in 0.3s ease;\n  max-width: 380px;\n}\n.lc-toast-success { background: #10B981; }\n.lc-toast-error   { background: #EF4444; }\n.lc-toast-warning { background: #F59E0B; }\n\n@keyframes lc-slide-in {\n  from { transform: translateX(120%); opacity: 0; }\n  to   { transform: translateX(0); opacity: 1; }\n}\n\n/* ── Card: Badge de status ─────────────────── */\n.camp-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #fff;\n  letter-spacing: 0.5px;\n  z-index: 1;\n}\n\n.camp-status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.7);\n}\n\n/* ── Card: Meta info ───────────────────────── */\n.camp-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n.camp-meta-item {\n  font-size: 13px;\n  color: #4B5563;\n}\n\n/* ── OVERLAY ───────────────────────────────── */\n.ed-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: 1000;\n  display: flex;\n  justify-content: flex-end;\n  animation: overlay-in 0.25s ease;\n}\n@keyframes overlay-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* ── DRAWER ────────────────────────────────── */\n.ed-drawer {\n  width: 520px;\n  max-width: 95vw;\n  height: 100vh;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -8px 0 40px rgba(0,0,0,0.18);\n  animation: drawer-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  overflow: hidden;\n}\n@keyframes drawer-in {\n  from { transform: translateX(100%); }\n  to   { transform: translateX(0); }\n}\n\n/* ── Header ────────────────────────────────── */\n.ed-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 22px 24px;\n  border-bottom: 1px solid #F3F4F6;\n  background: #FAFAFA;\n  flex-shrink: 0;\n}\n.ed-header-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.ed-status-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.ed-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 340px;\n}\n.ed-subtitle {\n  font-size: 12px;\n  color: #9CA3AF;\n  font-weight: 500;\n}\n.ed-close-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: none;\n  background: #F3F4F6;\n  color: #6B7280;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n.ed-close-btn:hover {\n  background: #EF4444;\n  color: white;\n}\n\n.ed-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.ed-delete-header-btn {\n  background: #FFF5F5;\n  color: #B91C1C;\n  border: 1px solid #FEE2E2;\n  padding: 8px 14px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n.ed-delete-header-btn:hover {\n  background: #EF4444;\n  border-color: #EF4444;\n  color: #fff;\n}\n\n.ed-delete-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 14px 24px;\n  background: #FFF5F5;\n  border-bottom: 1px solid #FEE2E2;\n  font-size: 13.5px;\n  color: #7F1D1D;\n}\n.ed-delete-banner-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n/* ── Tabs ──────────────────────────────────── */\n.ed-tabs {\n  display: flex;\n  border-bottom: 1px solid #E5E7EB;\n  overflow-x: auto;\n  flex-shrink: 0;\n  background: #fff;\n  padding: 0 16px;\n}\n.ed-tabs::-webkit-scrollbar { height: 3px; }\n.ed-tab {\n  white-space: nowrap;\n  padding: 14px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #9CA3AF;\n  border: none;\n  background: none;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n.ed-tab:hover { color: #111827; }\n.ed-tab.active {\n  color: #111827;\n  border-bottom-color: #111827;\n}\n\n/* ── Body ──────────────────────────────────── */\n.ed-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n.ed-body::-webkit-scrollbar { width: 6px; }\n.ed-body::-webkit-scrollbar-track { background: #F9FAFB; }\n.ed-body::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 3px; }\n\n.ed-section {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Inscritos ─────────────────────────────── */\n.ed-insc-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 12px;\n}\n.ed-insc-stat {\n  background: #F9FAFB; border: 1px solid #E5E7EB; border-radius: 12px;\n  padding: 14px 16px; display: flex; flex-direction: column; gap: 4px;\n}\n.ed-insc-stat span { font-family: 'JetBrains Mono', monospace; font-size: 20px; font-weight: 600; color: #111827; }\n.ed-insc-stat small { font-size: 11.5px; color: #6B7280; text-transform: uppercase; letter-spacing: .03em; }\n.ed-insc-stat-green span { color: #0F4A2A; }\n.ed-insc-stat-amber span { color: #4A2F08; }\n.ed-insc-stat-cobalt { background: #FEE2E2; border-color: #F5B5B5; }\n.ed-insc-stat-cobalt span { color: #991B1B; }\n\n.ed-insc-table thead th:last-child { width: 1%; }\n.ed-insc-atleta { display: flex; align-items: center; gap: 10px; border-left: 3px solid var(--faixa-cor, #DEDACB); padding-left: 8px; }\n.ed-insc-atleta div { display: flex; flex-direction: column; gap: 1px; }\n.ed-insc-atleta b { font-size: 13.5px; color: #111827; }\n.ed-insc-atleta small { font-size: 11.5px; color: #6B7280; }\n.ed-insc-avatar {\n  flex-shrink: 0; width: 30px; height: 30px; border-radius: 50%;\n  background: #FEE2E2; color: #991B1B;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 11.5px; font-weight: 700;\n}\n.ed-insc-valor { font-family: 'JetBrains Mono', monospace; font-size: 13px; }\n\n/* ── Fields ────────────────────────────────── */\n.ed-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n.ed-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n}\n.ed-field input,\n.ed-field select,\n.ed-field textarea {\n  padding: 10px 14px;\n  border: 1.5px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #111827;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  width: 100%;\n  box-sizing: border-box;\n  background: #fff;\n}\n.ed-field input:focus,\n.ed-field select:focus,\n.ed-field textarea:focus {\n  outline: none;\n  border-color: #111827;\n  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.08);\n}\n.ed-field-row {\n  display: flex;\n  gap: 12px;\n}\n.ed-field-small {\n  max-width: 120px;\n}\n.required { color: #EF4444; }\n\n/* ── Info box ──────────────────────────────── */\n.ed-info-box {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  background: #EFF6FF;\n  border: 1px solid #BFDBFE;\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #1E40AF;\n}\n.ed-hint {\n  font-size: 12px;\n  color: #9CA3AF;\n  margin: 0;\n}\n\n/* ── Capa ──────────────────────────────────── */\n.ed-capa-preview {\n  border-radius: 12px;\n  overflow: hidden;\n  background: #F3F4F6;\n  min-height: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ed-capa-img {\n  width: 100%;\n  max-height: 260px;\n  object-fit: cover;\n  display: block;\n}\n.ed-capa-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #9CA3AF;\n  font-size: 14px;\n  min-height: 180px;\n}\n.ed-capa-empty span { font-size: 40px; }\n.ed-upload-btn {\n  display: inline-block;\n  background: #111827;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-align: center;\n}\n.ed-upload-btn:hover { background: #374151; }\n.ed-remove-capa {\n  background: none;\n  border: 1.5px solid #EF4444;\n  color: #EF4444;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.ed-remove-capa:hover { background: #EF4444; color: white; }\n\n/* ── Premiações / Lotes ────────────────────── */\n.ed-list-item {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  background: #F9FAFB;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  padding: 14px;\n}\n.ed-list-item-body {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n}\n.ed-remove-item {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  background: #FEE2E2;\n  color: #EF4444;\n  font-size: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n.ed-remove-item:hover { background: #EF4444; color: white; }\n.ed-add-btn {\n  background: none;\n  border: 2px dashed #D1D5DB;\n  color: #6B7280;\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 100%;\n}\n.ed-add-btn:hover { border-color: #111827; color: #111827; }\n\n/* ── Status Selector ───────────────────────── */\n.ed-status-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.ed-status-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 2px solid #E5E7EB;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n}\n.ed-status-option.selected {\n  border-color: var(--status-color);\n  background: color-mix(in srgb, var(--status-color) 10%, white);\n  color: var(--status-color);\n}\n.ed-status-option:hover {\n  border-color: var(--status-color);\n}\n\n/* ── Zona de Perigo ────────────────────────── */\n.ed-danger-zone {\n  margin-top: 8px;\n  border: 2px solid #FEE2E2;\n  border-radius: 12px;\n  padding: 20px;\n  background: #FFF5F5;\n}\n.ed-danger-zone h4 {\n  margin: 0 0 8px;\n  color: #991B1B;\n  font-size: 15px;\n}\n.ed-danger-zone p {\n  font-size: 13px;\n  color: #7F1D1D;\n  margin: 0 0 16px;\n}\n.ed-delete-btn {\n  background: #EF4444;\n  color: white;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.ed-delete-btn:hover { background: #DC2626; }\n.ed-confirm-delete p {\n  font-size: 13px;\n  color: #991B1B;\n  margin-bottom: 12px;\n}\n.ed-confirm-btns {\n  display: flex;\n  gap: 10px;\n}\n.ed-cancel-btn {\n  background: #F3F4F6;\n  color: #374151;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.ed-cancel-btn:hover { background: #E5E7EB; }\n\n/* ── Footer ────────────────────────────────── */\n.ed-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 24px;\n  border-top: 1px solid #E5E7EB;\n  background: #FAFAFA;\n  flex-shrink: 0;\n}\n.ed-btn-cancel {\n  background: #F3F4F6;\n  color: #374151;\n  border: none;\n  padding: 11px 22px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.ed-btn-cancel:hover { background: #E5E7EB; }\n.ed-btn-save {\n  background: #111827;\n  color: white;\n  border: none;\n  padding: 11px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 8px rgba(17, 24, 39, 0.3);\n}\n.ed-btn-save:hover:not(:disabled) { background: #374151; }\n.ed-btn-save:disabled,\n.ed-btn-cancel:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* ── Textarea fields ─────────────────────────── */\n.ed-field textarea {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1.5px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #111827;\n  background: #FAFAFA;\n  resize: vertical;\n  transition: border-color 0.2s;\n  line-height: 1.6;\n}\n.ed-field textarea:focus {\n  outline: none;\n  border-color: #6366F1;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(99,102,241,0.08);\n}\n\n/* ── Checkbox group ──────────────────────────── */\n.ed-checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px;\n  background: #F9FAFB;\n  border: 1.5px solid #E5E7EB;\n  border-radius: 8px;\n}\n.ed-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n  cursor: pointer;\n}\n.ed-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #6366F1;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
